module.exports = __webpack_public_path__ + "img01.png";